import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTopbarHiddenTopWide: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="topbar-hidden-top-wide"><path fillRule="evenodd" clipRule="evenodd" d="M18.25 4C20.3211 4 22 5.67893 22 7.75V16.25C22 18.3211 20.3211 20 18.25 20H5.75C3.67893 20 2 18.3211 2 16.25V7.75C2 5.67893 3.67893 4 5.75 4H18.25ZM7 8C6.58579 8 6.25 8.33579 6.25 8.75C6.25 9.16421 6.58579 9.5 7 9.5H17C17.4142 9.5 17.75 9.16421 17.75 8.75C17.75 8.33579 17.4142 8 17 8H7Z" fill="currentColor"/></CentralIconBase>;
};

export default IconTopbarHiddenTopWide;
